import type { ReactNode } from "react";

/** A selectable / actionable row in an {@link ActionMenu}. */
export interface ActionMenuOption {
  /** Stable key — also the selection value when `selectionMode="single"`. */
  id: string;
  label: string;
  /** Desktop dropdown + Android sheet (left-aligned) show icons; the iOS sheet stays icon-less. */
  icon?: ReactNode;
  /** Fired on press. Ignored for link rows (use `href`). */
  onAction?: () => void;
  /** Renders the row as a link instead of a button. */
  href?: string;
  /** Destructive emphasis (pink/500 text). */
  destructive?: boolean;
  isDisabled?: boolean;
  /** Hide on the desktop dropdown (mobile sheet only) — e.g. a "start chat" row desktop surfaces elsewhere. */
  mobileOnly?: boolean;
}

/** A visual divider in the desktop dropdown (the mobile sheet's rows are uniformly divided, so it ignores these). */
export interface ActionMenuSeparator {
  type: "separator";
}

export type ActionMenuEntry = ActionMenuOption | ActionMenuSeparator;

export function isSeparator(entry: ActionMenuEntry): entry is ActionMenuSeparator {
  return "type" in entry;
}
